import React, { createContext, Dispatch, SetStateAction, useCallback, useState } from 'react';
import { MandatoryChildren } from '../../../../models/children-props';
import { CoreImportFolderFieldsFragment, ImportSourceFieldsFragment } from '../../../../models/graphql';
import { TreeMenuModalTypeEnums } from '../../../../constants/find-content';

export type TreeMenuProviderType = {
  folders: CoreImportFolderFieldsFragment[];
  sources: ImportSourceFieldsFragment[];
  selectedMenuItem: CoreImportFolderFieldsFragment | ImportSourceFieldsFragment | undefined;
  setSelectedMenuItem: Dispatch<
    SetStateAction<CoreImportFolderFieldsFragment | ImportSourceFieldsFragment | undefined>
  >;
  modalType: TreeMenuModalTypeEnums | undefined;
  setModalType: Dispatch<SetStateAction<TreeMenuModalTypeEnums | undefined>>;
  closeHandler: CallableFunction;
  reFetchTreeMenu: CallableFunction;
  setActionCondition: (
    type: TreeMenuModalTypeEnums | undefined,
    item: ImportSourceFieldsFragment | CoreImportFolderFieldsFragment | undefined
  ) => void;
};

export type TreeMenuProviderProps = MandatoryChildren & {
  reFetchTreeMenu: CallableFunction;
  folders: CoreImportFolderFieldsFragment[];
  sources: ImportSourceFieldsFragment[];
};

export const TreeMenuContext = createContext<TreeMenuProviderType>({
  folders: [],
  sources: [],
  selectedMenuItem: undefined,
  setSelectedMenuItem: () => {
    // ...
  },
  modalType: undefined,
  setModalType: () => {
    // ...
  },
  closeHandler: () => {
    // ...
  },
  reFetchTreeMenu: () => {
    // ...
  },
  setActionCondition: () => {
    // ...
  }
});

export const TreeMenuProvider = (props: TreeMenuProviderProps): JSX.Element => {
  const { reFetchTreeMenu, folders, sources } = props;

  // const [folders, setFolders] = useState<CoreImportFolderFieldsFragment[]>([]);
  // const [sources, setSources] = useState<ImportSourceFieldsFragment[]>([]);
  const [modalType, setModalType] = useState<TreeMenuModalTypeEnums | undefined>(undefined);
  const [selectedMenuItem, setSelectedMenuItem] = useState<
    ImportSourceFieldsFragment | CoreImportFolderFieldsFragment | undefined
  >(undefined);

  const setActionCondition = useCallback(
    (
      type: TreeMenuModalTypeEnums | undefined,
      item: ImportSourceFieldsFragment | CoreImportFolderFieldsFragment | undefined
    ) => {
      setModalType(type);
      setSelectedMenuItem(item);
    },
    [setModalType, setSelectedMenuItem]
  );

  return (
    <TreeMenuContext.Provider
      value={{
        folders,
        sources,
        selectedMenuItem,
        setSelectedMenuItem,
        modalType,
        setModalType,
        closeHandler: () => setActionCondition(undefined, undefined),
        reFetchTreeMenu,
        setActionCondition
      }}>
      {props.children}
    </TreeMenuContext.Provider>
  );
};
